import React from "react";
import { Box, Typography } from "@mui/material";

const TopSearchedCategoryCard = ({ label, value, maxValue, onActivate }) => {
  const pct = maxValue > 0 ? Math.round((value / maxValue) * 100) : 0;

  return (
    <Box
      role={onActivate ? "button" : undefined}
      tabIndex={onActivate ? 0 : undefined}
      onClick={onActivate}
      onKeyDown={
        onActivate
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onActivate();
              }
            }
          : undefined
      }
      sx={{
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        border: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "0 1px 3px rgba(15, 23, 42, 0.06)",
        px: 2,
        py: 1.25,
        cursor: onActivate ? "pointer" : "default",
        userSelect: "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          gap: 1.5,
        }}
      >
        <Typography
          sx={{
            fontFamily: "Rubik",
            fontWeight: 600,
            color: "#334155",
            fontSize: 13,
            width: { xs: "100%", sm: 220 },
            flexShrink: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: { xs: "normal", sm: "nowrap" },
            textAlign: { xs: "left", sm: "left" },
            alignSelf: { xs: "flex-start", sm: "center" },
          }}
          title={label}
        >
          {label}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flex: 1, minWidth: 0 }}>
          <Box sx={{ flex: 1, width: "100%", height: 12, backgroundColor: "#f1f5f9", borderRadius: 2, overflow: "hidden" }}>
            <Box sx={{ height: "100%", width: `${pct}%`, backgroundColor: "#0b3d87", borderRadius: 2 }} />
          </Box>
          <Typography
            sx={{
              fontFamily: "Rubik",
              fontWeight: "bold",
              color: "#0b3d87",
              fontSize: 13,
              minWidth: 40,
              pl: 2,
              pr: 2,
              textAlign: "right",
              flexShrink: 0,
              tabularNums: true,
            }}
          >
            {value}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TopSearchedCategoryCard;
